import './BookingCarouselMobileState.css'
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import { FiCalendar, FiClock, FiUsers, FiX } from "react-icons/fi";
import { GiWineBottle } from "react-icons/gi";
import { Link } from 'react-router-dom';
import CountdownCircle from './CountdownCircle';


export default function BookingCarouselMobileState({ combinedLeads, PreState }) {


    return (
        <Swiper
            modules={[Pagination]}
            pagination={{
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 5,
            }}
            spaceBetween={20}
            slidesPerView={1}
            className="bids-state-swiper"
        >
            {combinedLeads.map((item, index) => (
                <SwiperSlide key={index}>
                    <div className="bids-state-booking-card">
                        {/* Header */}
                        <div className="bids-state-booking-header">
                            <span className="bids-state-header-item">
                                <FiCalendar /> {item?.party_date}
                            </span>
                            <span className="bids-state-header-item">
                                <FiClock /> {item?.party_time}
                            </span>
                            <span className="bids-state-header-item">
                                <GiWineBottle /> {item?.title?.length > 12 ? `${item?.title?.slice(0, 12)}...` : item?.title}
                            </span>
                            <span className="bids-state-header-item">
                                <FiUsers /> {Number(item?.female) + Number(item?.male) + Number(item?.kids)}
                            </span>
                        </div>

                        {/* Body */}

                        {PreState === "waiting" && (
                            <div className="bids-state-booking-body">
                                <div className="bids-state-booking-progress">
                                    <CountdownCircle totalTime={60} size={40} color="#6f5fff" />
                                </div>
                                <div className="bids-state-booking-info">
                                    <h4>{item?.title}</h4>
                                    <p>{item?.status}</p>
                                </div>
                                <div className="bids-state-booking-action">
                                    <button disabled className="bids-state-view-btn-disabled">View Bids</button>
                                    {/* <span className="bids-state-close-btn">
                                        <FiX />
                                    </span> */}
                                </div>
                            </div>
                        )}

                        {PreState === "bids" && (
                            <div className="bids-state-booking-body">
                                {item?.bids?.length == 0 ? (
                                    <>
                                        <div className="bids-state-booking-progress">
                                            <CountdownCircle totalTime={60} size={40} color="#6f5fff" />
                                        </div>
                                        <div className="bids-state-booking-info">
                                            <h4>{item?.type === "package" ? "Group Booking" : "Table Booking"}</h4>
                                            <p>Wating for Bids</p>
                                        </div>
                                    </>
                                ) : (
                                    <div className="bids-state-booking-info">
                                        <h4>{item?.type === "package" ? "Group Booking" : "Table Booking"}</h4>
                                        <p>{item?.bids?.length} bids received</p>
                                    </div>
                                )}
                                <div className="bids-state-booking-actionLink">
                                    {item?.bids?.length > 0 ? (
                                        <Link
                                            to={`/bid-list/${item?.id}?source=${item?.type}`}
                                            style={{ textDecoration: "none" }}
                                        >
                                            <button className="bids-state-view-btn">View Bids</button>
                                        </Link>
                                    ) : (
                                        <button disabled className="bids-state-view-btn-disabled">View Bids</button>
                                    )}
                                    {/* <span className="bids-state-close-btn">
                                        <FiX />
                                    </span> */}
                                </div>
                            </div>
                        )}

                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}
